"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.METER_PER_SECOND_IN_KILOMETERS_PER_HOUR = void 0;
exports.METER_PER_SECOND_IN_KILOMETERS_PER_HOUR = 3.6;
//# sourceMappingURL=speed.js.map